import { useQuery } from '@apollo/client';
import type { Data } from '../models/dealer';
import { BY_DEALER_ID } from '../utils/graphql/dealers';

export function useSearchByDealerId(dealerId: string | null) {
  const { error, loading, data } = useQuery<Data, { dealerId: string | null }>(BY_DEALER_ID, {
    fetchPolicy: 'no-cache',
    variables: {
      dealerId,
    },
    skip: !dealerId,
  });
  return {
    error,
    loading,
    dealer: data ? data.dealerById : undefined,
  };
}
